import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import CheckmarkIcon from '../../../../../../../components/icons/CheckmarkIcon';
import DismissButton from '../../../../../../../components/global/DismissButton';
import withModal from '../../../../../../../components/global/modal/withModal';

const propTypes = {
  className: PropTypes.string,
  shutterbugPlusPlan: PropTypes.shape({
    id: PropTypes.string,
    price: PropTypes.shape({
      value: PropTypes.number.isRequired,
    }),
  }).isRequired,
  shutterbugPlusPremiumPlan: PropTypes.shape({
    id: PropTypes.string,
    price: PropTypes.shape({
      value: PropTypes.number.isRequired,
    }),
  }).isRequired,
  onRequestClose: PropTypes.func,
  onClose: PropTypes.func.isRequired,
  freePlanHidden: PropTypes.bool,
};

const FEATURES = () => {
  return [
    {
      labelId: 'STORAGE',
      label: 'Photo & video storage',
      type: String,
      values: ['10GB', '200GB'],
    },
    {
      labelId: 'AUTOMATIC_DELIVERY',
      label: (
        <>
          Automated photo <br className="d-md-none" />
          delivery (w/ facial rec)
        </>
      ),
      type: String,
      values: [
        <span className="text-light h1 text-extra-bold">&times;</span>,
        '10 People',
      ],
    },
    {
      labelId: 'SLIDESHOWS',
      label: (
        <>
          AI-powered slideshow <br className="d-md-none" />
          builder
        </>
      ),
      type: Boolean,
      values: [false, true],
    },
    {
      labelId: 'DISCOUNTS',
      label: (
        <>
          Discount on prints, <br className="d-md-none" />
          special events, &amp; more
        </>
      ),
      type: String,
      values: [
        <span className="text-light h1 text-extra-bold">&times;</span>,
        '15% off',
      ],
    },
    {
      labelId: 'MODERATION',
      label: (
        <>
          Photo &amp; member <br className="d-md-none" />
          moderation
        </>
      ),
      type: Boolean,
      values: [false, true],
    },
    {
      labelId: 'PLATFORMS',
      label: (
        <>
          Web, iOS, &amp; Android <br className="d-md-none" />
          access
        </>
      ),
      type: Boolean,
      values: [true, true],
    },
  ].filter(Boolean);
};

export const PHOTO_SEARCH_FEATURE_COMPARISON =
  'modal/PHOTO_SEARCH_FEATURE_COMPARISON';

const PhotoSearchFeatureComparisonModal = ({
  className,
  onClose,
  onRequestClose,
  freePlanHidden = false,
}) => {
  const classes = classNames({
    [className]: !!className,
  });

  return (
    // This will catch any unexpected click on the modal which would trigger
    // the parent, a toggle-able button, from toggling unintentionally.

    <div
      tabIndex={0}
      role="button"
      className={classes}
      onClick={event => event.stopPropagation()}
    >
      <div className="mb-1 text-right">
        <DismissButton onClick={onClose || onRequestClose} />
      </div>
      <h3 className="text-center">Personal plan comparison</h3>
      <div className="table-responsive">
        <table className="table table-striped waldofied-features-table text-dark">
          <thead>
            <tr>
              <th>&nbsp;</th> {/** Actions. */}
              {!freePlanHidden && (
                <th className="text-bold text-dark text-center">Basic</th>
              )}
              <th className="text-bold text-dark text-center">
                <span className="text-primary">Plus</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {FEATURES().map(feature => (
              <tr key={feature.labelId ?? feature.label}>
                <td className="text-left">{feature.label}</td>
                {feature.type === Boolean ? (
                  <Fragment>
                    {!freePlanHidden && (
                      <td>
                        {feature.values[0] ? (
                          <CheckmarkIcon color="#0d84fe" />
                        ) : (
                          <span className="text-light h1 text-extra-bold">
                            &times;
                          </span>
                        )}
                      </td>
                    )}
                    <td>
                      {feature.values[1] ? (
                        <CheckmarkIcon color="#0d84fe" />
                      ) : (
                        <span className="text-light h1 text-extra-bold">
                          &times;
                        </span>
                      )}
                    </td>
                  </Fragment>
                ) : (
                  <Fragment>
                    {!freePlanHidden && <td>{feature.values[0]}</td>}
                    <td>{feature.values[1]}</td>
                  </Fragment>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

PhotoSearchFeatureComparisonModal.propTypes = propTypes;

export default withModal(PhotoSearchFeatureComparisonModal, {
  name: PHOTO_SEARCH_FEATURE_COMPARISON,
  overlayClassName: 'waldofied-features-comparison-overlay',
  dismissible: false,
  hideHeader: true,
  type: 'full',
  size: 'md',
});
